function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function HighlightedText({ text, keyword }: { text: string; keyword: string }) {
  if (!keyword) return text;

  const escapedKeyword = escapeRegExp(keyword);
  const regex = new RegExp(`(${escapedKeyword})`, "gi");

  return text.split(regex).map((part, i) => {
    if (part.toLowerCase() === keyword.toLowerCase()) {
      return (
        <span key={i} className="text-primary-700 font-medium">
          {part}
        </span>
      );
    }
    return <span key={i}>{part}</span>;
  });
}
